// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"396":"012c0fd016fd8aa8","888":"ba9915c727b85256"}[chunkId] + ".css";
};